module.exports = __webpack_public_path__ + "img/bank_06.04361070.png";